/*
 * Flash
 * Copyright 2019
 * Author: Jon Bowes <jon@jbxonline.net>.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 */
/* global define */
(function (define) {
    define(['jquery'], function ($) {
        return (function () {

            var flash = {
                success: success,
                info: info,
                alert: alert
            };

            return flash;

            function notify (status, message) {
                $('<div>')
                    .addClass('alert alert-' + status)
                    .append(
                        $('<div>')
                            .addClass('container')
                            .html(message)
                    ).insertBefore($('main'));
            }

            function success (message) {
                notify('success', message);
            }

            function info (message) {
                notify('info', message);
            }

            function alert (message) {
                notify('danger', message);
            }

        })();
    });
}(typeof define === 'function' && define.amd ? define : function (deps, factory) {
    if (typeof module !== 'undefined' && module.exports) { //Node
        module.exports = factory(require('jquery'));
    } else {
        window.flash = factory(window.jQuery);
    }
}));